import React, { useState } from 'react';
import './Profile.scss';
import Address from '../../Components/Address/Address';
import { MdOutlineDelete } from 'react-icons/md';
import { CiCalendarDate, CiEdit } from 'react-icons/ci';
import { LiaStarSolid } from 'react-icons/lia';
import { IoMdPrint } from 'react-icons/io';
import { IoCheckmarkSharp, IoTimerSharp } from 'react-icons/io5';

import person from "../../Assets/user.png"
const Profile = () => {
    const [activeRow, setActiveRow] = useState(null);
  
    const toggleDetails = (index) => {
      setActiveRow(activeRow === index ? null : index);
    };
  return (
    <div className="profile-container">
      <h4 className='address'>Profile</h4>
      
  <div className='team mb-4'>

        {/* Member Info */}
        <div className='member-info'>
          <img src={person} alt="person" />
          <div>
            <h6 className='name'>Mr Osama Ali</h6>
            <div className="role-status">
              <span className="role">HR</span>
              <span className="succfull"><IoCheckmarkSharp /></span>
            </div>
          </div>
        </div>

        {/* Info Boxes */}
        <div className='info-box'>
          <p className='label'>Start Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Live Working Time</p>
          <div className='working-time'><IoTimerSharp /><span>00:30:00</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Last Activity</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

        <div className='info-box'>
          <p className='label'>Join Date</p>
          <div className='info-content'><CiCalendarDate /><span>25/5/2025</span></div>
        </div>

       
        <div>
          <span className="order-details" onClick={() => toggleDetails(0)}>...</span>
        </div>
          {activeRow === 0 && (
        <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <IoMdPrint style={{ fontSize: "20px" }} />
                Print
              </td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              {/* <td style={{ padding: "10px" }}>12:00 PM</td> */}
            </tr>
          </tbody>

          {/* إذا تريد تكرار نفس الجدول (مثل ما في كودك مرتين) فقط انسخ الـ <thead> و <tbody> مرة ثانية */}
          <thead style={{  marginTop: "20px", borderBottom:"1px solid #f6f6f6" }}>
            <tr style={{ color: "#999999", textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Full Name</td>
              <td style={{ padding: "10px" }}>PHONE</td>
              <td style={{ padding: "10px" }}>EMAIL</td>
              <td style={{ padding: "10px" }}>COUNTRY</td>
              <td style={{ padding: "10px" }}>DATE</td>
              <td style={{ padding: "10px" }}>Time</td>
              <td style={{ padding: "10px" }}>Print</td>
            </tr>
          </thead>
          <tbody style={{ backgroundColor: "white", textAlign: "center" , borderBottom:"1px solid #f6f6f6"}}>
            <tr>
              <td style={{ padding: "10px"}}>Osama Ali alabyaare</td>
              <td style={{ padding: "10px" }}>+20 1012345678</td>
              <td style={{ padding: "10px" }}>osama@email.com</td>
              <td style={{ padding: "10px" }}>Egypt</td>
              <td style={{ padding: "10px" }}>12/12/23</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
              <td style={{ padding: "10px" }}>12:00 PM</td>
            </tr>
          </tbody>
        </table>
      )}


    {activeRow === 0 && (
  <table className="details-table container mx-auto" style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
    <thead> 
      <tr style={{ color: "black", width:"100%" }}>
        <th colSpan={12} style={{ padding: "10px", textAlign: "center" ,backgroundColor:"#f6f6f6"}}>
          Performance
        </th>
      </tr>
    </thead>


       <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Performance</td>
              <td style={{ padding: "10px" }}>Level</td>
              <td style={{ padding: "10px" }}>Commitment</td>
              <td style={{ padding: "10px" }}>Behavior</td>
              <td style={{ padding: "10px" }}>Evaluation</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
      <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>average</td>
              <td style={{ padding: "10px" }}>admin</td>
              <td style={{ padding: "10px" }}>very good</td>
              <td style={{ padding: "10px" }}>very good

</td>
              <td style={{ padding: "10px" }}><LiaStarSolid  style={{
                color:"yellow"
              }}/>
<LiaStarSolid   style={{
                color:"yellow"
              }}/>
<LiaStarSolid />
<LiaStarSolid /></td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>

      <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Projects</td>
              <td style={{ padding: "10px" }}>Developments</td>
              <td style={{ padding: "10px" }}>Promotion</td>
              <td style={{ padding: "10px" }}>Notifications</td>
              <td style={{ padding: "10px" }}>Extra time</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>No</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>7 H</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>






           <thead >
            <tr style={{  textAlign: "center" }}>
              <td style={{ padding: "10px" }}>Asbence</td>
              <td style={{ padding: "10px" }}>Delay</td>
              <td style={{ padding: "10px" }}>Permission</td>
              <td style={{ padding: "10px" }}>Deduct</td>
              <td style={{ padding: "10px" }}>Bonus</td>
              <td style={{ padding: "10px" }}>Actions</td>
            
            </tr>
          </thead>
         <tbody style={{ backgroundColor:"#f6f6f6", textAlign: "center" }}>
            <tr className=' container w-75 mx-auto'>
              <td style={{ padding: "10px"}}>0</td>
              <td style={{ padding: "10px" }}>0</td>
              <td style={{ padding: "10px" }}>2</td>
              <td style={{ padding: "10px" }}>2

</td>
              <td style={{ padding: "10px" }}>1</td>

    <td style={{ padding: "10px" }}><CiEdit style={{
      fontSize:"20px",
      marginRight:"10px"
    }}/>
<MdOutlineDelete    style={{
      fontSize:"20px"
    }}/>

          </td>
             
            </tr>
          </tbody>
  </table>
)}










      </div>

      <div className="profile-performance">
        <h4>Performance</h4>
        <table>
          <thead>
            <tr>
              <th>Performance</th>
              <th>Level</th>
              <th>Commitment</th>
              <th>Behavior</th>
              <th>Rating</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>average</td>
              <td>Admin</td>
              <td>very good</td>
              <td>very good</td>
              <td className="profile-rating-cell">
                <div className="profile-rating-stars">
                  {[1, 2, 3, 4, 5].map(i => (
                    <span key={i} className={i <= 4 ? 'star filled' : 'star'}>★</span>
                  ))}
                </div>
              </td>
            </tr>
            <tr>
              <td>Development</td>
              <td>promotion</td>
              <td>work hours</td>
              <td>extra time</td>
              <td></td>
            </tr>
            <tr>
              <td>Projects</td>
              <td>0</td>
              <td>no</td>
              <td>6 H Per day</td>
              <td>5 H in month</td>
            </tr>
            <tr>
              <td>Absence</td>
              <td>1</td>
              <td>permission</td>
              <td>Deduct</td>
              <td>Deduct</td>
            </tr>
            <tr>
              <td>Delay</td>
              <td>3</td>
              <td>1</td>
              <td>2</td>
              <td>2</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Profile;
